<template>
  <div class="container__layout">
    <svg
      width="100%"
      version="1.1"
      id="torotate"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 5760 4440"
      style="enable-background: new 0 0 1684.08 1191.24"
      xml:space="preserve"
    >
      <image
        style="overflow: visible"
        width="5760"
        height="4440"
        xlink:href="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/aniversarioclubgolf/MesasClub19aniv.png"
      ></image>
      <polygon
        v-for="(table, index) in tables"
        :key="'A' + index"
        :style="statusColor(table)"
        :points="table.coordinates"
        :name="`${table.name}`"
        shape="polygon"
        class="polygon"
      />
    </svg>
    <tippy
      theme="club"
      arrow="true"
      size="large"
      distance="3"
      ignoreAttributes="true"
      interactive="true"
      animation="fade"
      allowHTML="true"
      v-for="(table, index) in tables"
      :key="'B' + index"
      :to="`${table.name}`"
    >
      <tooltip-aniversario :table="table" />
    </tippy>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TooltipAniversario from "../core/TooltipAniversarioClubDeGolf.vue";

export default {
  name: "Menu",
  components: {
    TooltipAniversario,
  },
  data() {
    return {
      id: 4,
      opacity: 0.6,
      disponible: "67B63B",
      reservado: "FFFF00",
      vendido: "F52A11",
      
    };
  },
  computed: {
    ...mapGetters({
      tables: "getTables",
    }),
    development() {
      return { id: this.id, level: 0 };
    },
  },
  methods: {
    ...mapActions(["getAvailableTables"]),
    statusColor(table) {
       if(table.reserved == 10 && table.available == 0){
      return `stroke-width:3; stroke:#${this.vendido}; opacity: ${this.opacity}; fill: #${this.vendido}`;
      }else if(table.reserved > 0){
      return `stroke-width:3; stroke:#${this.reservado}; opacity: ${this.opacity}; fill: #${this.reservado}`;
      }else{
      return `stroke-width:3; stroke:#${this.disponible}; opacity: ${this.opacity}; fill: #${this.disponible}`;
      }

    },
    updated(){

    }
  },
  mounted() {
    this.getAvailableTables(this.development);


    setInterval(() =>{
    this.getAvailableTables(this.development);
    },60000)
  },
};
</script>

<style lang="css" scoped>
.container__layout {
  width: 100%;
}
svg {
  width: 100%;
}
polygon {
  cursor: pointer;
  outline: none;
}
</style>
